export const locales = {
  pt: {
    'Activar sonido': 'Ativar som',
    Silenciar: 'Silenciar',
    'Ver películas, series y más': 'Assistir filmes, séries e muito mais',
    'Tráiler de': 'Trailer de',
    'que se reproduce automáticamente': 'que é reproduzido automaticamente',
    Logotipo: 'Logotipo',
    Antes: 'Antes',
    'Calificación {0} de cinco. {1} opinión.': 'Classificação {0} de cinco. {1} opinião.',
    'Calificación {0} de cinco. {1} opiniones.': 'Classificação {0} de cinco. {1} opiniões.',
  },
};

export const translate = (msg: string, values?: string[]): string => {
  const { hostname } = window.location;
  const lang = hostname.includes('com.br') ? 'pt' : 'es';

  let translatedMsg: string = locales[lang as keyof object]?.[msg as keyof object] || msg;

  if (values && values.length > 0) {
    translatedMsg = translatedMsg.replace(/\{(\d+)\}/g, (_:any, index:number) => values[index] || '');
  }

  return translatedMsg;
};
